import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { ChancenkurveLevelConfig } from './ChancenkurveLevelConfig.js';

/**
 * Threshold configuration for a specific subject (German or Math Subtraction)
 */
@Entity()
export class ChancenkurveSubjectConfig extends AdornisEntity {
  static override _class = 'ChancenkurveSubjectConfig';

  /**
   * Subject identifier: 'german' or 'math_subtraction'
   */
  @Field(() => String)
  subject: Maybe<string>;

  /**
   * Entry level ID for students with no test history
   */
  @Field(() => String)
  entryLevel: Maybe<string>;

  /**
   * Array of level configurations for this subject
   */
  @Field(() => [ChancenkurveLevelConfig])
  levels: Maybe<ChancenkurveLevelConfig[]>;
}
